import blankProfile from "../../images/blank-profile.png";
import FormikTextField from "../../../../Common/FormFields/FormikInputField";
import { FormGroup } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomDropDown from "../../../../Common/FormFields/CustomDropDown";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../../utils/constant";
import { Form, Formik } from "formik";
import { addVideoScheduleInformation } from "../../../../Redux/Actions/VideoScheduleAction";
const Opponent = ({ opponentSchoolImage, page, setPage }) => {
  const opponentSchoolList = useSelector(
    (state) => state?.loggedInUser?.schoolList
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );

  const dispatch = useDispatch();

  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      profileImage: user.uploadedLogo
        ? user.uploadedLogo.filePath
        : blankProfile,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
    };
  });
  return (
    <>
      <Formik
        initialValues={{
          schoolname: userInfo?.schoolDetails?.schoolName,
        }}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div className="d-flex-center gap-20">
              <div className="text-center white-card shadow video-streaming-opponent-card">
                <img
                  src={userInfo?.profileImage}
                  className="details-profile img-fluid"
                />
                <div>
                  <FormikTextField
                    label="School"
                    formik={formik}
                    fieldName="schoolname"
                    placeholder="Enter First name"
                    labelFontSize="fs-18"
                    isDisabled={true}
                  />
                </div>
              </div>
              <div className="text-center white-card shadow video-streaming-opponent-card">
                <img
                  src={opponentSchoolImage ? opponentSchoolImage : blankProfile}
                  className="details-profile img-fluid"
                />
                <div>
                  <FormGroup>
                    <label className="fmlabel mt-6 semi-bold fs-18">
                      Select Opponent <span className="redstar">*</span>
                    </label>
                    <CustomDropDown
                      selected={videoScheduleInformation?.opponentName}
                      setSelected={(value) => {
                        addVideoScheduleInformation(dispatch, {
                          fieldName: "opponentName",
                          value,
                        });
                        addVideoScheduleInformation(dispatch, {
                          fieldName: "opponentId",
                          value: opponentSchoolList.filter(
                            (ele) => ele.schoolName == value
                          )[0].id,
                        });
                      }}
                      formik={formik}
                      fieldName="opponent"
                      defaultSelectOption="Select Opponent"
                      options={opponentSchoolList}
                      fieldToShow="schoolName"
                      optionValue="schoolName"
                    />
                  </FormGroup>
                </div>
              </div>
            </div>

            <div className="d-flex-center gap-20 mg-top-20">
              <button
                className={`${
                  !videoScheduleInformation?.opponentName
                    ? "saveBtn1 activv"
                    : "saveBtn1"
                } position-relative d-flex-center blur-filter-background z-0`}
                disabled={!videoScheduleInformation?.opponentName}
                onClick={() => {
                  setPage((page) => page + 1);
                }}
              >
                {page === 2 ? "Start Streaming" : "Next"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Opponent;
